import {
  CollectionDrillThroughAnalytics,
  CTAClickAnalyticsProps,
  DrillThroughLink
} from './collection-header.interface'
import { LiveEventStatus } from '../../../../../io/models/live-event'

export function getDrillThroughLinkAnalytics(drillThrough: DrillThroughLink): CollectionDrillThroughAnalytics {
  return {
    name: 'Drill Through Link',
    category_parent_name: !!drillThrough.parent && drillThrough.parent.name
  }
}

export const getCTAClickAnalyticsProps = (
  eventStatus?: LiveEventStatus | string,
  nodeId?: number | null,
  liveId?: number
): CTAClickAnalyticsProps => {
  return {
    event_status: eventStatus,
    live_id: liveId,
    node_id: nodeId
  }
}
